import ReactDOM from 'react-dom/client';
import App, { CustomError } from "./containers/App";
import { Provider } from "react-redux";
import configureStore from "./store";
import { BrowserRouter } from "react-router-dom";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

declare global {
  interface Window {
    __PRELOADED_STATE__: any;
  }
}

declare const module: {
  hot: {
    accept(): void;
  };
};

const store = configureStore(window.__PRELOADED_STATE__);

root.render(
  <CustomError>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </CustomError>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

if (module.hot) {
  module.hot.accept();
}
